import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';
import { StaticGoogleMap } from '@hivebrite/design-system/StaticGoogleMap';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';
import MapPreview from 'hb-react/shared/components/MapPreview';
import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import IconLocation from 'hb-react/shared/icons/Location';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import Landing from '../Landing';

const CheckIn = () => {
  const { flagGoogleMapsComponent } = useFeatureFlag();
  const { location } = useLandingContext();
  const frameTheme = useFrameTheme();

  const customMx = flagGoogleMapsComponent ? 0 : { _: -4, m: 0 };

  return (
    <Landing
      title={s__('LiveFeed|checked in at %{location}').i__({
        location: location?.address,
      })}
    >
      <Box mt={4} mx={customMx} display="block" css="position: relative;">
        {flagGoogleMapsComponent ? (
          <StaticGoogleMap
            apiKey={window.__HB_ENV__.GOOGLEMAPS_API_KEY}
            errorMessage={__('StaticGoogleMap|Error loading map')}
            footer={{
              iconName: 'location-dot',
              address: location?.address,
            }}
            latitude={location?.lat}
            longitude={location?.lng}
            zoom={13}
          />
        ) : (
          <>
            <MapPreview
              lat={location?.lat}
              lng={location?.lng}
              width="100%"
              height={200}
              zoom={14}
            />
            <ThemeProvider
              theme={frameTheme.themeName}
              fontBrightness={frameTheme.fontBrightness}
            >
              <Box
                bg={frameTheme.backgroundColor}
                p={3}
                pr={5}
                alignItems="center"
                css="position: absolute; bottom: 0; left: 0;"
              >
                <Box color="primary" mr={3}>
                  <IconLocation height={30} width={30} />
                </Box>
                <Box display="block">
                  <Box fontWeight={1}>
                    <Dotdotdot clamp={1}>{location?.address}</Dotdotdot>
                  </Box>
                </Box>
              </Box>
            </ThemeProvider>
          </>
        )}
      </Box>
    </Landing>
  );
};

export default CheckIn;
